import {Injectable, Injector} from '@angular/core';
import {ApiResponse, BaseApiService} from '../../base-api.service';
import {TransfersModelService} from '../../../Models/Warehouse/Transfers/transfers-model.service';
import {TransferFilters} from '../../../../Models/Warehouse/Transfers/transfer-filters.model';
import {TransferStatusEnum} from '../../../../Shared/Enum/transfer-status.enum';
import {TransferForm} from '../../../../Models/Warehouse/Transfers/transfer-store.model';
import {TransferProductForm} from '../../../../Models/Warehouse/Transfers/transfer-product-store.model';
import {
  SetTransferStateDto,
  TransferProductDto,
  TransferStateDto
} from '../../../../Models/Warehouse/Transfers/transfer.interface';

@Injectable({
  providedIn: 'root'
})
export class TransfersApiService extends BaseApiService {

  constructor(
    protected override injector: Injector,
    public model: TransfersModelService,
  ) {
    super(injector);
  }


  /**
   * Obtener traspasos
   *
   */
  getTransfers(filters: TransferFilters | null, save: boolean = true): Promise<ApiResponse> {

    return new Promise((resolve, reject) => {

      return this.httpCall('getTraslados', filters, 'post').subscribe({
        next: (response) => {
          if (save) {
            this.model.save(response.data);
          }

          resolve(response);
        },
        error: (err) => {
          reject(err);
        }
      });

    });

  }


  /**
   * Obtener traspaso
   *
   */
  public getTransferDetail(params: { id: number }): Promise<ApiResponse> {

    return new Promise((resolve, reject) => {

      return this.httpCall('getTraslado', params).subscribe({
        next: (response) => {
          resolve(response);
        },
        error: (err) => {
          reject(err);
        }
      });

    });

  }


  /**
   * Añadir traspaso
   *
   */
  public addTransfer(params: TransferForm): Promise<ApiResponse> {

    return new Promise((resolve, reject) => {

      return this.httpCall('openTraslado', params).subscribe({
        next: (response) => {
          resolve(response);
        },
        error: (err) => {
          reject(err);
        }
      });

    });

  }


  /**
   * Cancelar traspaso
   *
   */
  public cancelTransfer(params: { id: number; id_estado: number }): Promise<ApiResponse> {

    return new Promise((resolve, reject) => {

      return this.httpCall('setTrasladoEstado', params).subscribe({
        next: (response) => {
          resolve(response);
        },
        error: (err) => {
          reject(err);
        }
      });

    });

  }


  /**
   * Eliminar traspaso
   *
   */
  public deleteTransfer(params: { id: number }): Promise<ApiResponse> {

    return new Promise((resolve, reject) => {

      return this.httpCall('deleteTraspaso', params).subscribe({
        next: (response) => {
          resolve(response);
        },
        error: (err) => {
          reject(err);
        }
      });

    });

  }


  /**
   * Guardar producto al traspaso
   *
   */
  public setTransferProduct(params: TransferProductDto | TransferProductForm): Promise<ApiResponse> {

    return new Promise((resolve, reject) => {

      return this.httpCall('setTrasladoLineas', params).subscribe({
        next: (response) => {
          resolve(response);
        },
        error: (err) => {
          reject(err);
        }
      });

    });

  }


  /**
   * Eliminar producto al traspaso
   *
   */
  public deleteTransferProduct(params: { id: number }): Promise<ApiResponse> {

    return new Promise((resolve, reject) => {

      return this.httpCall('deleteProductoTraslado', params).subscribe({
        next: (response) => {
          resolve(response);
        },
        error: (err) => {
          reject(err);
        }
      });

    });

  }


  /**
   * Guardar estado del traspaso
   *
   */
  public setTransferState(params: SetTransferStateDto): Promise<ApiResponse> {

    return new Promise((resolve, reject) => {

      return this.httpCall('setTrasladoEstado', params).subscribe({
        next: (response) => {
          resolve(response);
        },
        error: (err) => {
          reject(err);
        }
      });

    });

  }


  /**
   * Guardar imagen del traspaso
   *
   */
  public setTransferImage(params: FormData): Promise<ApiResponse> {

    return new Promise((resolve, reject) => {

      return this.httpCall('setTrasladoFoto', params).subscribe({
        next: (response) => {
          resolve(response);
        },
        error: (err) => {
          reject(err);
        }
      });

    });

  }


  /**
   * Eliminar imagen del traspaso
   *
   */
  public deleteTransferImage(params: { id_foto: number }): Promise<ApiResponse> {

    return new Promise((resolve, reject) => {

      return this.httpCall('deleteTrasladoFoto', params).subscribe({
        next: (response) => {
          resolve(response);
        },
        error: (err) => {
          reject(err);
        }
      });

    });

  }


  /**
   * Obtener los estados de un traspaso
   *
   */
  getTransfersStatus(): TransferStateDto[] {
    return [
      {
        value: TransferStatusEnum.pendent,
        name: 'CONST.TRANSFER_STATUS.PENDING'
      },
      {
        value: TransferStatusEnum.sent,
        name: 'CONST.TRANSFER_STATUS.SENT'
      },
      {
        value: TransferStatusEnum.received,
        name: 'CONST.TRANSFER_STATUS.RECEIVED'
      },
    ];
  }

}
